import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'respuestasRapid'
})
export class RespuestasRapidasPipe implements PipeTransform {

  transform(arreglo: any[], texto: string, idAdmin: number): any[] {
    if(!texto){
      return arreglo;
    }

    if( arreglo.length === 0 ) {
      return arreglo;
    }
    texto = texto.toLocaleLowerCase();

    if (idAdmin === 72) {
      return arreglo.filter(item =>
        item.titulo.toLowerCase().includes(texto)
      );
    }

    return arreglo.filter( item => {
      return item.titulo.toLowerCase().includes(texto) || item.frase.toLowerCase().includes(texto);
    });
  }
}


